export const MAX_MOBILE_SCREEN_WIDTH = 1024;
export const identity = v => v;
